import { Pipe, PipeTransform } from "@angular/core";

let numeral: any = require('numeral');
let lodash: any = require('lodash');

@Pipe({ name: "dkNumber" })
export class DkNumberPipe implements PipeTransform {
    transform(value: number, precision: number = null, numberOfDecimalPlaces: number = 0): string {
        let result: string;
        precision = precision || 6;
        let zerosNumber = '';
        let zeros = '';

        lodash.times(numberOfDecimalPlaces, () => {
            zerosNumber += '0';
        });

        lodash.times(precision - numberOfDecimalPlaces, () => {
            zeros += '0';
        });

        let format = `0.${zerosNumber}[${zeros}]`;

        if (value != null) {
            return numeral(value).format(format);
        }

        return '';
    }

    parse(value: string): number {
        let reg = /^\d+[\.,]?\d*$/;

        if ((value == null) || !reg.test(value)) {
            return null;
        }

        return numeral(value.replace('.',',')).value();
    }
}